module.exports = __webpack_public_path__ + "static/media/best.474e4baf.svg";